import { useState } from "react";
import { IconQueue } from "@/components/ui/icons";
import { Modal } from "@/components/ui/Modal";
import { usePlayer } from "@/hooks/usePlayer";

export function QueueDrawer() {
  const [open, setOpen] = useState(false);
  const { current, upNext, isRecommended } = usePlayer();
  return (
    <>
      <button title="File d'attente" onClick={() => setOpen(true)}><IconQueue /></button>
      <Modal open={open} onClose={() => setOpen(false)} title="File d'attente">
        <ol style={{ margin: 0, padding: 0, listStyle: "none", maxHeight: "60vh", overflow: "auto" }}>
          {current && (
            <li style={{ padding: "8px 10px", borderRadius: 8, background: "var(--accent-soft)" }}>
              <div className="muted" style={{ fontSize: 11, letterSpacing: 1 }}>EN COURS</div>
              <div className="trunc" style={{ fontWeight: 700 }}>{current.title}</div>
              <div className="muted trunc">{current.artist.name}</div>
            </li>
          )}
          {upNext.length > 0 && (
            <li className="muted" style={{ fontSize: 11, letterSpacing: 1, padding: "14px 10px 4px" }}>À SUIVRE</li>
          )}
          {upNext.map((t, i) => (
            <li key={t.id + i} style={{ padding: "8px 10px", borderRadius: 8 }}>
              <div className="trunc" style={{ fontWeight: 500 }}>
                {isRecommended(t.id) && <span className="rec-star" title="Recommandé">✦ </span>}{t.title}
              </div>
              <div className="muted trunc">{t.artist.name}</div>
            </li>
          ))}
        </ol>
      </Modal>
    </>
  );
}
